export default __webpack_public_path__ + "2ef05e2f83c0336c1d480b6b46619e5f.png";